module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_35.540ccad2.png";